$(window).on('load', function() {
  //検索フィルターのセール価格のAbove%を%以上に変更
  var Above = $(".boost-pfs-filter-option-value:contains('Above ')");
  Above.append(' 以上');
  var AboveTxt = Above.text();
  AboveTxt = AboveTxt.replace('Above ', '');
  Above.text(AboveTxt);
  
  //検索フィルターのセール価格のUnder%を%以下に変更
  var Under = $(".boost-pfs-filter-option-value:contains('Under ')");
  Under.append(' 以下');
  var UnderTxt = Under.text();
  UnderTxt = UnderTxt.replace('Under ', '');
  Under.text(UnderTxt);
  
  //見出しのcolorをカラーに変更（カラーチップのlabel合わせの対策）
  var Color = $(".boost-pfs-filter-option.boost-pfs-filter-option-color .boost-pfs-filter-option-title-text");
  var ColorTxt = Color.html();
  ColorTxt = ColorTxt.replace('color', 'カラー');
  Color.html(ColorTxt);
  
  //検索設定ごとに項目が変化するため修正  
  $('body').on('mouseup touchend keydown', '.boost-pfs-filter-left-col *' , function() {
    console.log('hoge');
    setTimeout(function(){
      //以上
      var AboveChange = $(".boost-pfs-filter-option-value:contains('Above ')");
      if(AboveChange.length){
        AboveChange.text(AboveTxt);
      }
      
      //以下
      var UnderChange = $(".boost-pfs-filter-option-value:contains('Under ')");;
      if(UnderChange.length){
        UnderChange.text(UnderTxt);
      }    
    
      //カラー
      $(".boost-pfs-filter-option.boost-pfs-filter-option-color .boost-pfs-filter-option-title-text").html(ColorTxt);
	},500);
  });

});

